export class ModelConstants {
  /**
   * 制御周期の最大値
   */
  static readonly FKDPPINTERVAL_MAX = 60000;
  /**
   * 制御周期の最小値
   */
  static readonly FKDPPINTERVAL_MIN = 10;
  /**
   * 間接制御時の実験時間の最大値
   */
  static readonly EXPTIME_MAX = 600000;
  /**
   * 間接制御時の実験時間の最小値
   */
  static readonly EXPTIME_MIN = 0.01;
  /**
   * 目標値の最大値
   */
  static readonly SP_MAX = 999999;
  /**
   * 目標値の最小値
   */
  static readonly SP_MIN = -999999;
  /**
   * 比例帯の最大値
   */
  static readonly PB_MAX = 999.9;
  /**
   * 比例帯の最小値
   */
  static readonly PB_MIN = 0.1;
  /**
   * 積分時間の最大値
   */
  static readonly TD_MAX = 6000;
  /**
   * 積分時間の最小値
   */
  static readonly TD_MIN = 0;
  /**
   * 微分時間の最大値
   */
  static readonly TI_MAX = 6000;
  /**
   * 微分時間の最小値
   */
  static readonly TI_MIN = 0;
  /**
   * 制御レンジ上限の最大値
   */
  static readonly RANGEMAX_MAX = 999999;
  /**
   * 制御レンジ上限の最小値
   */
  static readonly RANGEMAX_MIN = -999999;
  /**
   * 制御レンジ下限の最大値
   */
  static readonly RANGEMIN_MAX = 999999;
  /**
   * 制御レンジ下限の最小値
   */
  static readonly RANGEMIN_MIN = -999999;
  
  /**
   * PID切り替えタイミングのPVの最大値
   */
  static readonly PIDPV_MAX = 999999;
  /**
   * PID切り替えタイミングのPVの最小値
   */
  static readonly PIDPV_MIN = -999999;
  /**
   * PID切り替えタイミングのステップ数の最大値
   */
  static readonly PIDSTEP_MAX = 10000;
  /**
   * PID切り替えタイミングのステップ数の最小値
   */
  static readonly PIDSTEP_MIN = 0;
  /**
   * シミュレーション時間の最大値
   */
  static readonly TIME_MAX = 10000;
  /**
   * シミュレーション時間の最小値
   */
  static readonly TIME_MIN = 1;

  /**
   * 比例帯の初期値（表示の関係上文字列で設定）
   */
  static readonly PB_INIT = "5.0";
  /**
   * 積分時間の初期値
   */
  static readonly TI_INIT = 240;
  /**
   * 微分時間の初期値
   */
  static readonly TD_INIT = 60;
  /**
   * PID制御周期の初期値（文字列）
   */
  static readonly PIDINTERVAL_INIT = "200";

  /**
   * PID切り替えタイミングのステップ数の初期値
   */
  static readonly PIDSTEP_INIT = 10;
  /**
   * シミュレーション時間の初期値
   */
  static readonly TIME_INIT = 2000;
}
